import useClientOpportunity from '@modules/opportunities/entities/opportunity/query/useClientOpportunity';
import { CaseCreationLayoutRoute } from '@modules/opportunities/presentation/routes';

import { IS_UAE_ENV } from '@modules/core/utils';
import { HuspyAndBankSubmission } from './features/HuspyAndBankSubmission';
import { HuspySubmission } from './features/HuspySubmission';

const SubmitApplications = () => {
  const { opportunityId } = CaseCreationLayoutRoute.useParams();
  const { data: opportunityData } = useClientOpportunity(opportunityId);

  if (IS_UAE_ENV) {
    return (
      <HuspyAndBankSubmission opportunity={ opportunityData?.opportunity! } />
    );
  }
  return (
    <HuspySubmission
      opportunityId={ opportunityId }
      bankApplications={ opportunityData?.opportunity.bank_applications! }
      clientExternalId={ opportunityData?.opportunity.client_external_id! }
    />
  );
};

export default SubmitApplications;
